// eslint-disable-next-line
export function setMapDisplay(state, value) {
  // console.log('ui/mutations setMapDisplay()', value);
  state.displayMap = value;
}

export function setPanelView(state, value) {
  state.panelView = value;
}

export function setDetailedCommunity(state, value) {
  state.mapDetailCommunity = value;
}

export function setDetailedQuickMoveIn(state, value) {
  state.mapDetailQuickMoveIn = value;
}

export function setZoomToLocation(state, value) {
  state.zoomToLocation = value;
}
